import { CHAINID } from 'config/constants/chain_config';
import { useMemo } from 'react';

export const useGetChainId = (id: number | CHAINID) => {
  return useMemo(() => {
    return `${id}` as CHAINID;
  }, [id]);
};
